import { LegoInit, LegoPerf } from '@zz-biz/adapter'
// babel core-js@3
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@zz/sasscore/flexible.js'
import { Toast, Lazyload, Button } from '@zz-common/zz-ui'
import { SetPicSize } from '@zz-biz/utils'
import { BuzzSetting, Buzz } from '@zz-biz/request'
import { SentryVueInit, SentryCapture } from '@zz-common/sentry'
import Vue from 'vue'
import ErrorBoundary from '@/utils/ErrorBoundary'
import '@/assets/css/reset.css'
import App from '../App.vue'

// 设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

class MainApp {
  public router: any
  constructor(rout: any) {
    this.router = rout
  }

  public init(legoP = {}) {
    // 全局注册组件
    Vue.use(Toast).use(Lazyload).use(Button, { v8: true })
    tryCatch(() => {
      // 全局初始化乐高埋点的值
      if (Object.keys(legoP).length > 0) {
        // 向LegoInit传参传参
        LegoInit(legoP)
      } else {
        LegoInit()
      }
    })
    // 错误监控平台
    this.useSentry()
    this.request()
    // 全局注册方法$setPicSize
    Vue.prototype.$setPicSize = SetPicSize
    // 性能监控平台
    this.Perf()
    // 全局注册自定义组件
    Vue.use(ErrorBoundary)
    // 注册vue实例
    this.mount()
  }

  public mount() {
    const router = this.router
    new Vue({
      router,
      render: (h) => h(App)
    }).$mount('#app')
  }

  // sentry
  public useSentry() {
    tryCatch(() => {
      SentryVueInit()
    })
  }

  // 设置请求包
  public request() {
    tryCatch(() => {
      // 设置请求初始化
      BuzzSetting({
        baseURL: 'https://app.zhuanzhuan.com',
        globalTips: (err: any) => {
          Toast.fail(err || '网络错误')
        }
      })
      Vue.prototype.$Buzz = Buzz
      // 也附到全部变量给js文件用
      ;(window as any).Buzz = Buzz
    })
  }

  // 性能监控
  public Perf() {
    tryCatch(() => {
      LegoPerf()
    })
  }
}
Vue.config.errorHandler = (err, vm, info) => {
  SentryCapture(err, 2)
}

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}

export default MainApp
